import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { AttachmentInfo, ItemInfo, PurchaseDetailInfo, PurchaseInfo} from 'src/app/models/models';
import { Currency, Currency_Rate, Purchase, Purchase_Detail, Store, User} from 'src/app/models/RestModels';
import { forkJoin, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import {Utils} from 'src/app/classes/Utils';
import { GetEmpty } from 'src/app/classes/Empties';
import { FacturaMetaData } from 'src/app/classes/FacturaMetaData';

declare function txt2html(str:string):string;
declare function printHtml(html_body:string,title:string):any;

interface CItemAdd
{
	item_info:ItemInfo;
	qty:number;
}

interface CfdiConcepto
{
	descripcion: string;
	cantidad: number;
	valorUnitario: number;
	importe: number;
	claveUnidad: string;
	unidad: string;
	matched_item?: ItemInfo;
	search_str?: string;
	// Tax fields
	totalIva: number;          // IVA (Impuesto 002)
	totalIeps: number;         // IEPS (Impuesto 003)
	totalTraslados: number;    // Sum of all transferred taxes (IVA + IEPS + others)
	totalRetenciones: number;  // Sum of ISR and other withheld taxes
}

@Component({
	selector: 'app-save-purchase',
	templateUrl: './save-purchase.component.html',
	styleUrls: ['./save-purchase.component.css']
})
export class SavePurchaseComponent extends BaseComponent implements OnInit
{


	show_item_exists_modal: boolean = false;
	item_to_add: ItemInfo | null = null;
	show_change_provider_modal: boolean = false;
	change_provider_search: string = '';
	change_provider_list: User[] = [];

	purchase_info:PurchaseInfo	= this.getEmptyPurchaseInfo();
	item_info_list:ItemInfo[] = [];
	input_search:string = '';
	show_provider_list:boolean = false;
	provider_user_list:User[] = [];
	show_add_new:boolean = false;
	show_new_provider:boolean = false;
	store_list:Store[] = [];
	currency_list:Currency[] = [];
	currency_rate_list:Currency_Rate[] = [];
	item_count:number = 0;
	total_items:number = 0;
	search_str:string = '';

	note:string = '';
	paid_date:string = '';
	reference:string = '';
	transaction_type: "CASH" | "TRANSFER" | "CREDIT_CARD" | "DEBIT_CARD" | "CHECK" | "COUPON" | "DISCOUNT" | "RETURN_DISCOUNT" | "PAYPAL";
	facturaMetadata:FacturaMetaData = new FacturaMetaData('');

	// XML Factura properties
	xml_attachment_id: number | null = null;
	cfdi_conceptos: CfdiConcepto[] = [];
	show_cfdi_modal: boolean = false;
	loading_cfdi: boolean = false;
	cfdi_emisor: { rfc: string; nombre: string } = { rfc: '', nombre: '' };
	cfdi_folio: string = '';
	cfdi_fecha: string = '';
	cfdi_total: string = '';

	// Flags to show/hide tax columns based on data presence
	show_iva_column: boolean = false;
	show_ieps_column: boolean = false;
	show_isr_column: boolean = false;

	// Edit price modal
	show_edit_price_modal: boolean = false;
	edit_price_item: PurchaseDetailInfo | null = null;
	edit_price_value: number = 0;

	ngOnInit()
	{
		this.sink = this.route.paramMap
		.pipe
		(
			mergeMap((params)=>
			{
				this.is_loading = true;
				this.input_search = '';
				return forkJoin
				({
					stores: this.rest.store.search({limit:9999,sort_order:['name_ASC']}),
					purchase: params.has('id')
						? this.rest.purchase_info.get( params.get('id') )
						: of( this.getEmptyPurchaseInfo() ),
					provider: params.has('provider_id') ? this.rest.user.get( params.get('provider_id') ) : of(null as User),
					currency: this.rest.currency.search({limit:9999,sort_order:['name_ASC']}),
					currency_rate: this.rest.currency_rate.search({limit:9999,sort_order:['currency_id_ASC']}),
				})
			})
		)
		.subscribe
		({
			next:(response)=>
			{
				this.store_list = response.stores.data;
				if( response.purchase.bill == null )
				{
					response.purchase.bill = {
						paid_status: 'PENDING',
						total: response.purchase.purchase.total
					}
				}

				this.currency_list = response.currency.data;
				this.currency_rate_list = response.currency_rate.data;

				this.is_loading = false;
				this.purchase_info = response.purchase;


				if( response.purchase.purchase.id )
				{
					this.purchase_info.store = this.store_list.find(i=>i.id == response.purchase.purchase.store_id) || null
				}
				else if( this.rest.current_user.store_id )
				{
					this.purchase_info.store = this.store_list.find(i=>i.id == this.rest.current_user.store_id) || null;
					this.purchase_info.purchase.store_id = this.rest.current_user.store_id;
				}

				if( response.provider )
				{
					this.userProviderSelected( response.provider );
				}

				this.updateTotal();
			},
			error:(error)=>this.showError( error )
		});
	}

	getExchangeRate(currency_id:string):number
	{
		if( this.purchase_info.bill.currency_id == currency_id )
			return 1;

		let store = this.store_list.find((s:Store)=>s.id == this.purchase_info.purchase.store_id) as Store;
		let default_currency_id = store.default_currency_id;

		let currency_rate = this.currency_rate_list.find((r:Currency_Rate)=>
		{
			console.log('COnsole',r);
			if( r.store_id != this.purchase_info.purchase.store_id )
				return false;

			if( this.purchase_info.bill.currency_id == default_currency_id )
			{
				return r.currency_id == currency_id;
			}

			return r.currency_id == this.purchase_info.bill.currency_id;
		});

		if( !currency_rate )
		{

		}

		return default_currency_id == this.purchase_info.bill.currency_id
			? currency_rate.rate
			: 1/currency_rate.rate;
	}

	searchProvider(provider_name:string)
	{
		this.show_provider_list = true;
		this.purchase_info.purchase.provider_name = provider_name;
		this.purchase_info.purchase.provider_user_id = null;

		this.subs.sink = this.rest.user.search(
		{
			start:{	name:provider_name },
			eq:{ status:'ACTIVE'},
			search_extra:{'user_permission.is_provider':1},
			limit: 20
		})
		.subscribe((response)=>
		{
			this.provider_user_list = response.data;
		});
	}

	addNewProvider(provider_name: string)
	{
		this.is_loading = true;
		this.show_provider_list = false;

		let user: Partial<User> = {
			name: provider_name,
			email: provider_name,
			store_id: undefined,
			type: 'USER',
			credit_days: 0,
			credit_limit: 0,
			price_type_id: undefined,
		};

		let user_permission = GetEmpty.user_permission();
		user_permission.is_provider = 1;

		this.subs.sink = this.rest.user
		.create(user).pipe
		(
			mergeMap((response)=>
			{
				user_permission.user_id = response.id;
				this.purchase_info.purchase.provider_user_id = response.id;
				this.purchase_info.bill.provider_user_id = response.id;

				return this.rest.user_permission.update(user_permission);
			})
		)
		.subscribe
		({
			next: (response)=>
			{
				this.is_loading = false;
				this.showSuccess('Se agregó un nuevo proveedor');
				this.provider_user_list = [];
			},
			error: (error)=>
			{
				this.is_loading = false;
				this.showError(error);
			}
		});
	}

	userProviderSelected(user:User)
	{
		this.show_provider_list = false;
		this.purchase_info.purchase.provider_name = user.name;
		this.purchase_info.purchase.provider_user_id = user.id;
		this.purchase_info.bill.provider_user_id = user.id;
		this.provider_user_list = [];
	}

	getEmptyPurchaseInfo():PurchaseInfo
	{
		let purchase:Purchase = {
			stock_status: 'PENDING',
			order_id: null,
			store_id: this.rest?.current_user?.store_id	|| 0,
			created: new Date(),
			updated: new Date(),
			created_by_user_id: this.rest?.current_user?.id || 0,
			provider_name: '',
			status: 'ACTIVE',
			provider_user_id: null,
			updated_by_user_id: null,
			total: 0,
			id: 0,
		};

		let p:PurchaseInfo = {
			purchase,
			bill: {
				paid_status: 'PENDING',
				currency_id: 'MXN',
				amount_paid: 0,
				total: 0
			},
			details:[] as PurchaseDetailInfo[],
			shipping: null,
			bank_movements_info: [],
		};

		return p;
	}

	save()
	{
		this.is_loading = true;

		//se toma por hecho que no hay pagos, y si se marca, para pagarlo completo
		if (this.purchase_info.bill.paid_status == 'PAID' && this.purchase_info.bank_movements_info.length == 0)
		{
			this.markAsPaid();
		}

		if( this.purchase_info.purchase.id	)
		{
			this.purchase_info.purchase.total =this.purchase_info.bill.total;

			this.subs.sink = this.rest.purchase_info.update( this.purchase_info )
			.subscribe
			({
				next: (purchase)=>
				{
					this.is_loading = false;
					this.router.navigate(['/list-purchase']);
					this.showSuccess('La orden de compra se actualizó exitosamente');
				},
				error: (error)=>
				{
					this.is_loading = false;
					this.showError(error);
				}
			});
		}
		else
		{
			this.purchase_info.purchase.total =this.purchase_info.bill.total;

			if( !this.rest.current_permission.global_purchases )
			{
				this.purchase_info.purchase.store_id = this.rest.current_user.store_id;
			}

			if (!this.purchase_info.purchase.provider_user_id)
			{
				this.is_loading = false;
				this.showError('Debe seleccionar un proveedor existente de la lista o registrar uno nuevo');
				return;
			}

			this.subs.sink = this.rest.purchase_info.create(this.purchase_info)
			.subscribe
			({
				next: (purchase)=>
				{
					this.is_loading = false;
					this.showSuccess('La orden de compra se guardó exitosamente');
					this.router.navigate(['/list-purchase']);
				},
				error: (error)=>
				{
					this.is_loading = false;
					this.showError(error);
				}
			});
		}
	}

	onInput(evt:Event)
	{
		if( evt.target['value'] == '' )
		{
			this.item_info_list = [];
			return;
		}

		let input = evt.target as HTMLInputElement;
		this.subs.sink = this.rest.item_info.search({
			eq:{status:'ACTIVE'},
			search_extra:{category_name:input.value}
		})
		.subscribe((response)=>
		{
			this.item_info_list = response.data;
		});
	}

	onItemInfoSelect(item_info:ItemInfo, qty:number=1)
	{
		console.log('Item ifno has', item_info.item );
		if( this.purchase_info.details.some((i)=>i.purchase_detail.item_id == item_info.item.id && item_info.item.has_serial_number == "NO") )
		{
			this.item_to_add = item_info;
			this.show_item_exists_modal = true;
			return;
		}

		this.show_add_new = false;

		this.item_info_list = [];

		let purchase_detail:Purchase_Detail = {
			purchase_id: this.purchase_info.purchase.id,
			item_id	:	item_info.item.id,
			status: 'ACTIVE',
			qty: qty,
			stock_status: 'PENDING',
			description: '',
			id: 0,
			total: 0,
			serial_number: item_info.item.has_serial_number == 'YES' ? '' : null,
			created: new Date(),
			updated: new Date(),
			unitary_price: ( item_info.item.reference_price || 0.0 ) * this.getExchangeRate( item_info.item.reference_currency_id )
		};

		this.purchase_info.details.push
		({
			purchase_detail: purchase_detail,
			item: item_info.item,
			category: item_info.category
		})

		this.updateTotal();

		this.input_search = '';
	}

	incrementExistingItem()
	{
		let existing_item = this.purchase_info.details.find(i => i.item.id === this.item_to_add.item.id);
		existing_item.purchase_detail.qty++;
		this.updateTotal();
		this.show_item_exists_modal = false;
		this.item_to_add = null;
	}

	cancelAddExistingItem()
	{
		this.show_item_exists_modal = false;
		this.item_to_add = null;
	}

	onItemScannedAdd(item_add:CItemAdd)
	{
		let purchase_detail = this.purchase_info.details.find(i=>i.purchase_detail.item_id == item_add.item_info.item.id);

		if( purchase_detail )
		{
			purchase_detail.purchase_detail.qty += item_add.qty;
		}
		else
		{
			this.onItemInfoSelect(item_add.item_info, item_add.qty);
		}

		this.updateTotal();
	}



	updateTotal()
	{
		this.purchase_info.purchase.total = this.purchase_info.details.reduce((prev,pi)=>{
			if( pi.purchase_detail.unitary_price && pi.purchase_detail.qty)
				return prev+pi.purchase_detail.unitary_price * pi.purchase_detail.qty;
			return prev;
		},0);

		this.total_items = this.purchase_info.details.reduce((prev,pi)=>prev+pi.purchase_detail.qty,0);

		this.purchase_info.bill.total = Math.round( this.purchase_info.purchase.total*100 )/100;
	}

	removeItem(pid:PurchaseDetailInfo)
	{
		if( !pid.purchase_detail.id )
		{
			let index = this.purchase_info.details.findIndex(i=>i===pid);
			if( index > -1 )
				this.purchase_info.details.splice(index,1);
		}
		else
		{
			pid.purchase_detail.status = 'DELETED';
		}
	}
	showAddNewItem()
	{
		this.search_str = '';
		this.show_add_new = true;
	}

	toggleMarkAsPaid()
	{
		this.purchase_info.bill.paid_status = this.purchase_info.bill.paid_status == 'PAID' ? 'PENDING' : 'PAID';
	}

	markAsPaid()
	{
		this.purchase_info.bill.amount_paid = this.purchase_info.bill.total;
		this.purchase_info.bill.paid_by_user_id = this.rest.current_user.id;
		this.purchase_info.bill.paid_date = Utils.getUTCMysqlStringFromDate(new Date());
		this.purchase_info.bill.aproved_by_user_id = this.rest.current_user.id;
		this.purchase_info.bill.accepted_status = 'ACCEPTED';

		//set the bank movement info
		this.purchase_info.bank_movements_info.push({
			bank_movement:{
				id: null,
				amount_received: this.purchase_info.bill.total,
				bank_account_id: null,
				card_ending: null,
				client_user_id: null,
				created: new Date(),
				currency_id: this.purchase_info.bill.currency_id || 'MXN',
				invoice_attachment_id: this.purchase_info.bill.invoice_attachment_id,
				note: this.note,
				origin_bank_name: null,
				paid_date: this.paid_date,
				payment_id: null,
				provider_user_id: this.purchase_info.bill.provider_user_id ? this.purchase_info.bill.provider_user_id : null,
				receipt_attachment_id: this.purchase_info.bill.receipt_attachment_id,
				received_by_user_id: null,
				reference: this.reference,
				status: 'ACTIVE',
				exchange_rate: 1,
				total: this.purchase_info.bill.total,
				transaction_type: this.transaction_type,
				type: 'expense',
				updated: new Date(),
			}
			,bank_movement_bills:
			[{
				bank_movement_bill:{
					amount: this.purchase_info.bill.total,
					currency_amount: this.purchase_info.bill.total,
					currency_id: this.purchase_info.bill.currency_id || 'MXN',
					exchange_rate: 1,
					status: 'ACTIVE',
				}
			}]
		});
	}

	print(evt:Event)
	{
		let store = this.store_list.find(i=>this.purchase_info.purchase.store_id == i.id);
		let store_name = txt2html(store?.name || '');
		let html = `
			<h1>Orden de compra ${this.purchase_info.purchase.id}</h1>
			<div>
				Proveedor:<b>${txt2html(this.purchase_info.purchase.provider_name)}</b>
			</div>
			<div>
				Sucursal:<b>${store_name}</b>
			</div>
			<div>
				Fecha:<b>${this.purchase_info.purchase.created.toLocaleString()}</b>
			</div>
			<table style="width:100%">
				<thead>
					<tr>
						<th style="text-align:left;">Articulo</th>
						<th style="text-align:right;">Cantidad</th>
						<th style="text-align:right;">Total</th>
					</tr>
				</thead>
				<tbody>
		`;

		let total = 0;
		let total_items = 0;

		this.purchase_info.details.forEach((di)=>
		{
			let cname = '';

			if( di.category && this.rest.local_preferences.display_categories_on_items == 'YES' )
				cname = di.category.name+' - ';

			total += di.purchase_detail.qty*di.purchase_detail.unitary_price;
			total_items += di.purchase_detail.qty;

			let ciname = txt2html( cname+' '+di.item.name );

			html += `<tr>
				<td style="text-align:left;">${ciname}</td>
				<td style="text-align:right;">${this.formatNumber( di.purchase_detail.qty)}</td>
				<td style="text-align:right;">${this.formatCurrency( di.purchase_detail.qty*di.purchase_detail.unitary_price) }</td>
			</tr>`;
		});

		html += `
			<tr>
				<td style="text-align:right;"><b>Total</b></td>
				<td style="text-align:right;"><b>${this.formatNumber(total_items)}</b></td>
				<td style="text-align:right;"><b>${this.formatCurrency(total)}</b></td>
			</tr>
		`;

		html += '</tbody></table>';

		//console.log( 'html is ', html);

		printHtml( html, 'purchase' );
	}
	currency_formater = new Intl.NumberFormat('us-EN', { style: 'currency', currency: 'USD', currencyDisplay:"narrowSymbol" });
	number_formater = new Intl.NumberFormat('us-EN', { maximumSignificantDigits: 2,} ); // useGrouping:"always"

	formatCurrency(amount:number):string
	{
		return this.currency_formater.format(amount);
	}
	formatNumber(amount:number):string
	{
		return this.number_formater.format(amount);
	}
	clone(pdi:PurchaseDetailInfo)
	{
		let purchase_detail = {...pdi.purchase_detail };
		purchase_detail.serial_number = '';
		purchase_detail.id = 0;

		this.purchase_info.details.push({
			purchase_detail,
			item:pdi.item,
			category:pdi.category
		})
	}

	closeScannerDialog()
	{
		let dialog = document.getElementById('scanner_dialog') as HTMLDialogElement;
		dialog.close();
	}

	showScanner()
	{
		let dialog = document.getElementById('scanner_dialog') as HTMLDialogElement;
		dialog.showModal();
	}

	onNoResultsFound(barcode: string)
	{
		this.search_str = barcode;
		this.showAddNewItem();
	}

	onXmlAttachmentChange(attachment_info: AttachmentInfo)
	{
		this.xml_attachment_id = attachment_info.attachment.id;
		this.loadAndParseXml();
	}

	loadAndParseXml()
	{
		if (!this.xml_attachment_id) return;

		this.loading_cfdi = true;
		let url = this.rest.getFilePath(this.xml_attachment_id, false);

		fetch(url)
		.then(response => response.text())
		.then(data => {
			this.cfdi_conceptos = this.parseConceptosFromXml(data);
			this.updateTaxColumnFlags();
			this.matchConceptosWithItems();
		})
		.catch(error => {
			console.error('Error al cargar el archivo XML', error);
			this.showError('Error al cargar el archivo XML');
			this.loading_cfdi = false;
		});
	}

	parseConceptosFromXml(data: string): CfdiConcepto[]
	{
		const parser = new DOMParser();
		const dom: XMLDocument = parser.parseFromString(data, "application/xml");
		let conceptos: CfdiConcepto[] = [];

		// Extract Comprobante attributes
		let comprobante = dom.getElementsByTagName("cfdi:Comprobante");
		if (comprobante.length > 0)
		{
			let comp = comprobante.item(0) as Element;
			this.cfdi_folio = comp.getAttribute('Folio') || '';
			this.cfdi_fecha = comp.getAttribute('Fecha') || '';
			this.cfdi_total = comp.getAttribute('Total') || '';
		}

		// Extract Emisor (provider) information
		let emisorElements = dom.getElementsByTagName("cfdi:Emisor");
		if (emisorElements.length > 0)
		{
			let emisor = emisorElements.item(0) as Element;
			this.cfdi_emisor = {
				rfc: emisor.getAttribute('Rfc') || '',
				nombre: emisor.getAttribute('Nombre') || ''
			};
		}

		// Extract Conceptos
		let conceptosElements = dom.getElementsByTagName("cfdi:Concepto");

		for (let i = 0; i < conceptosElements.length; i++)
		{
			let element = conceptosElements.item(i) as Element;
			let descripcion = element.getAttribute('Descripcion') || '';

			// Extract taxes from nested elements
			let totalIva = 0;
			let totalIeps = 0;
			let totalTraslados = 0;
			let totalRetenciones = 0;

			// Get cfdi:Impuestos child element
			let impuestosElements = element.getElementsByTagName("cfdi:Impuestos");
			if (impuestosElements.length > 0)
			{
				let impuestos = impuestosElements.item(0) as Element;

				// Sum Traslado imports by type (002=IVA, 003=IEPS)
				let trasladoElements = impuestos.getElementsByTagName("cfdi:Traslado");
				for (let j = 0; j < trasladoElements.length; j++)
				{
					let traslado = trasladoElements.item(j) as Element;
					let importe = parseFloat(traslado.getAttribute('Importe') || '0');
					let impuesto = traslado.getAttribute('Impuesto') || '';

					if (impuesto === '002') {
						totalIva += importe;
					} else if (impuesto === '003') {
						totalIeps += importe;
					}
					totalTraslados += importe;
				}

				// Sum all Retencion imports (ISR, etc.)
				let retencionElements = impuestos.getElementsByTagName("cfdi:Retencion");
				for (let j = 0; j < retencionElements.length; j++)
				{
					let retencion = retencionElements.item(j) as Element;
					totalRetenciones += parseFloat(retencion.getAttribute('Importe') || '0');
				}
			}

			conceptos.push({
				descripcion: descripcion,
				cantidad: parseFloat(element.getAttribute('Cantidad') || '0'),
				valorUnitario: parseFloat(element.getAttribute('ValorUnitario') || '0'),
				importe: parseFloat(element.getAttribute('Importe') || '0'),
				claveUnidad: element.getAttribute('ClaveUnidad') || '',
				unidad: element.getAttribute('Unidad') || '',
				search_str: '',
				totalIva: totalIva,
				totalIeps: totalIeps,
				totalTraslados: totalTraslados,
				totalRetenciones: totalRetenciones
			});
		}

		return conceptos;
	}

	updateTaxColumnFlags()
	{
		this.show_iva_column = this.cfdi_conceptos.some(c => c.totalIva > 0);
		this.show_ieps_column = this.cfdi_conceptos.some(c => c.totalIeps > 0);
		this.show_isr_column = this.cfdi_conceptos.some(c => c.totalRetenciones > 0);
	}

	matchConceptosWithItems()
	{
		if (this.cfdi_conceptos.length === 0)
		{
			this.loading_cfdi = false;
			this.showError('No se encontraron conceptos en el XML');
			return;
		}

		// Search for provider by name
		let providerPromise = this.cfdi_emisor.nombre
			? this.rest.user.search({
				lk: { name: this.cfdi_emisor.nombre },
				eq: { status: 'ACTIVE' },
				search_extra: { 'user_permission.is_provider': 1 },
				limit: 5
			}).toPromise()
			: Promise.resolve({ data: [] });

		let searchPromises = this.cfdi_conceptos.map(concepto => {
			return this.rest.item_info.search({
				lk: { name: concepto.descripcion },
				eq: { status: 'ACTIVE' },
				limit: 1
			}).toPromise();
		});

		Promise.all([providerPromise, ...searchPromises])
		.then(results => {
			// First result is the provider search
			let providerResult = results[0];
			if (providerResult.data.length > 0)
			{
				this.userProviderSelected(providerResult.data[0]);
			}
			else if (this.cfdi_emisor.nombre)
			{
				// Set the provider name from XML so user can register it
				this.purchase_info.purchase.provider_name = this.cfdi_emisor.nombre;
				this.purchase_info.purchase.provider_user_id = null;
			}

			// Set folio from XML
			if (this.cfdi_folio)
			{
				this.purchase_info.bill.folio = this.cfdi_folio;
			}

			// Rest of results are item searches
			results.slice(1).forEach((response, index) => {
				if (response.data.length > 0)
				{
					this.cfdi_conceptos[index].matched_item = response.data[0];
				}
			});
			this.loading_cfdi = false;
			this.show_cfdi_modal = true;
		})
		.catch(error => {
			console.error('Error al buscar artículos', error);
			this.showError('Error al buscar artículos coincidentes');
			this.loading_cfdi = false;
		});
	}

	searchItemForConcepto(concepto: CfdiConcepto, search_term: string)
	{
		this.subs.sink = this.rest.item_info.search({
			lk: { name: search_term },
			eq: { status: 'ACTIVE' },
			limit: 10
		}).subscribe({
			next: (response) => {
				if (response.data.length > 0)
				{
					concepto.matched_item = response.data[0];
				}
			},
			error: (error) => this.showError(error)
		});
	}

	addConceptosToPurchase()
	{
		let added_count = 0;

		this.cfdi_conceptos.forEach(concepto => {
			if (concepto.matched_item)
			{
				let existing = this.purchase_info.details.find(
					d => d.purchase_detail.item_id === concepto.matched_item.item.id
				);

				if (existing && concepto.matched_item.item.has_serial_number === "NO")
				{
					existing.purchase_detail.qty += concepto.cantidad;
					// Calculate tax per unit and include in unit price
					let taxPerUnit = (concepto.totalTraslados - concepto.totalRetenciones) / concepto.cantidad;
					existing.purchase_detail.unitary_price = (concepto.valorUnitario + taxPerUnit) * this.getExchangeRate(concepto.matched_item.item.reference_currency_id);
				}
				else
				{
					// Calculate tax per unit and include in unit price
					let taxPerUnit = (concepto.totalTraslados - concepto.totalRetenciones) / concepto.cantidad;
					let purchase_detail: Purchase_Detail = {
						purchase_id: this.purchase_info.purchase.id,
						item_id: concepto.matched_item.item.id,
						status: 'ACTIVE',
						qty: concepto.cantidad,
						stock_status: 'PENDING',
						description: concepto.descripcion,
						id: 0,
						total: concepto.importe + concepto.totalTraslados - concepto.totalRetenciones,
						serial_number: concepto.matched_item.item.has_serial_number === 'YES' ? '' : null,
						created: new Date(),
						updated: new Date(),
						unitary_price: (concepto.valorUnitario + taxPerUnit) * this.getExchangeRate(concepto.matched_item.item.reference_currency_id)
					};

					this.purchase_info.details.push({
						purchase_detail: purchase_detail,
						item: concepto.matched_item.item,
						category: concepto.matched_item.category
					});
				}
				added_count++;
			}
		});

		this.updateTotal();
		this.show_cfdi_modal = false;
		this.showSuccess(`Se agregaron ${added_count} artículos de la factura`);
	}

	clearConceptoMatch(concepto: CfdiConcepto)
	{
		concepto.matched_item = undefined;
		concepto.search_str = '';
	}

	selectItemForConcepto(concepto: CfdiConcepto, item_info: ItemInfo)
	{
		concepto.matched_item = item_info;
		concepto.search_str = '';
	}

	getMatchedConceptosCount(): number
	{
		return this.cfdi_conceptos.filter(c => c.matched_item).length;
	}

	getUnmatchedConceptosCount(): number
	{
		return this.cfdi_conceptos.filter(c => !c.matched_item).length;
	}

	getCfdiTotalCantidad(): number
	{
		return this.cfdi_conceptos.reduce((sum, c) => sum + c.cantidad, 0);
	}

	getCfdiTotalImporte(): number
	{
		return this.cfdi_conceptos.reduce((sum, c) => sum + c.importe, 0);
	}

	getCfdiTotalIva(): number
	{
		return this.cfdi_conceptos.reduce((sum, c) => sum + c.totalIva, 0);
	}

	getCfdiTotalIeps(): number
	{
		return this.cfdi_conceptos.reduce((sum, c) => sum + c.totalIeps, 0);
	}

	getCfdiTotalTraslados(): number
	{
		return this.cfdi_conceptos.reduce((sum, c) => sum + c.totalTraslados, 0);
	}

	getCfdiTotalRetenciones(): number
	{
		return this.cfdi_conceptos.reduce((sum, c) => sum + c.totalRetenciones, 0);
	}

	getCfdiTotalConImpuestos(): number
	{
		return this.cfdi_conceptos.reduce((sum, c) => sum + c.importe + c.totalTraslados - c.totalRetenciones, 0);
	}

	isCfdiTotalMatch(): boolean
	{
		let xmlTotal = parseFloat(this.cfdi_total) || 0;
		let calculatedTotal = this.getCfdiTotalConImpuestos();
		return Math.abs(xmlTotal - calculatedTotal) < 0.01;
	}

	showChangeProviderModal()
	{
		this.change_provider_search = '';
		this.change_provider_list = [];
		this.show_change_provider_modal = true;
	}

	searchProviderInModal(provider_name: string)
	{
		if (!provider_name || provider_name.length < 2) {
			this.change_provider_list = [];
			return;
		}

		this.subs.sink = this.rest.user.search({
			start: { name: provider_name },
			eq: { status: 'ACTIVE' },
			search_extra: { 'user_permission.is_provider': 1 },
			limit: 20
		}).subscribe({
			next: (response) => {
				this.change_provider_list = response.data;
			},
			error: (error) => this.showError(error)
		});
	}

	selectProviderFromModal(user: User)
	{
		this.is_loading = true;

		this.subs.sink = this.rest.updatePath('change_purchase_provider', {
			purchase_id: this.purchase_info.purchase.id,
			provider_user_id: user.id
		}).subscribe({
			next: () => {
				this.purchase_info.purchase.provider_name = user.name;
				this.purchase_info.purchase.provider_user_id = user.id;
				this.purchase_info.bill.provider_user_id = user.id;
				this.show_change_provider_modal = false;
				this.change_provider_list = [];
				this.change_provider_search = '';
				this.is_loading = false;
				this.showSuccess('Proveedor actualizado correctamente');
			},
			error: (error) => {
				this.is_loading = false;
				this.showError(error);
			}
		});
	}

	addNewProviderFromModal(provider_name: string)
	{
		this.is_loading = true;

		let user: Partial<User> = {
			name: provider_name,
			email: provider_name,
			store_id: undefined,
			type: 'USER',
			credit_days: 0,
			credit_limit: 0,
			price_type_id: undefined,
		};

		let user_permission = GetEmpty.user_permission();
		user_permission.is_provider = 1;

		this.subs.sink = this.rest.user
		.create(user).pipe
		(
			mergeMap((response) =>
			{
				user_permission.user_id = response.id;
				return this.rest.user_permission.update(user_permission).pipe
				(
					mergeMap(() =>
					{
						return this.rest.updatePath('change_purchase_provider', {
							purchase_id: this.purchase_info.purchase.id,
							provider_user_id: response.id
						}).pipe
						(
							mergeMap(() => of({ id: response.id, name: provider_name }))
						);
					})
				);
			})
		)
		.subscribe({
			next: (result) =>
			{
				this.purchase_info.purchase.provider_name = result.name;
				this.purchase_info.purchase.provider_user_id = result.id;
				this.purchase_info.bill.provider_user_id = result.id;
				this.show_change_provider_modal = false;
				this.change_provider_list = [];
				this.change_provider_search = '';
				this.is_loading = false;
				this.showSuccess('Proveedor registrado y asignado correctamente');
			},
			error: (error) =>
			{
				this.is_loading = false;
				this.showError(error);
			}
		});
	}

	showEditPriceModal(pdi: PurchaseDetailInfo)
	{
		this.edit_price_item = pdi;
		this.edit_price_value = pdi.purchase_detail.unitary_price;
		this.show_edit_price_modal = true;
	}

	saveEditedPrice()
	{
		if (!this.edit_price_item) return;

		this.is_loading = true;

		this.subs.sink = this.rest.updatePath('edit_purchase_item_price', {
			purchase_detail_id: this.edit_price_item.purchase_detail.id,
			unitary_price: this.edit_price_value
		}).subscribe({
			next: () =>
			{
				this.edit_price_item.purchase_detail.unitary_price = this.edit_price_value;
				this.updateTotal();
				this.show_edit_price_modal = false;
				this.edit_price_item = null;
				this.is_loading = false;
				this.showSuccess('Precio actualizado correctamente');
			},
			error: (error) =>
			{
				this.is_loading = false;
				this.showError(error);
			}
		});
	}
}
